import { useEffect, useState } from 'react';
import { APILinks } from 'constants/api';
import axios, { getPayloadFromError } from 'utils/axios';
import { toSnakeCase } from 'utils/response';
import get from 'lodash.get';
import find from 'lodash.find';
import reject from 'lodash.reject';
import { useDispatch } from 'react-redux';

// Interfaces
export type IID = number | string | null | undefined;
interface IInitialValuesItem {
  id: IID
  value: boolean
}
type IInitialValues = IInitialValuesItem[] | [];
interface IUseFetchToggle {
  isHas: boolean
  isHasList: IInitialValues
  isLoading: boolean
  handleToggle: () => void
}
interface IUseFetchToggleProps {
  initialValue?: boolean
  initialValues?: IInitialValues
  initialLoading?: boolean
  isDelete?: boolean
  apiLink: APILinks | string
  params?: Record<string, any>
  id: IID
  keyId?: string
  isMultiply?: boolean
}

// TODO Rou 29.10.2021 Need true loading Array?!
// Component
const useFetchToggle = (props: IUseFetchToggleProps): IUseFetchToggle => {
  const {
    initialValue = false,
    initialValues: basicInitialValues = [],
    initialLoading = true,
    isMultiply = false,
    isDelete = false,
    apiLink,
    id,
    keyId = 'id',
    params: restParams = {},
  } = props;

  const dispatch = useDispatch();

  const initialValues: IInitialValues = isMultiply
    ? basicInitialValues
    : [{ id, value: initialValue }];

  const [successId, setSuccessId] = useState<IID>(null);
  const [isHasList, setIsHasList] = useState<IInitialValues>(initialValues);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const currentValue: boolean = get(find(isHasList, (
    { id: itemId },
  ) => itemId === id), ['value'], initialValue);

  const [isHas, setIsHas] = useState<boolean>(currentValue);

  useEffect(() => {
    if (!initialLoading) {
      setIsHasList(initialValues);
    }
  }, [initialLoading]);

  useEffect(() => {
    setIsHas(currentValue);
  }, [currentValue]);

  useEffect(() => {
    if (successId === id) {
      setIsHas(currentValue);
    }
  }, [successId]);

  const handleToggle = () => {
    const params = {
      ...restParams,
      [keyId]: id,
    };

    setIsLoading(true);

    axios()
      .post(apiLink, {
        add: isDelete ? false : !currentValue,
        ...toSnakeCase(params),
      })
      .then(() => {
        setIsHasList([
          ...reject(isHasList, ({ id: itemId }) => itemId === id),
          {
            id,
            value: !currentValue,
          },
        ]);
        setSuccessId(id);
        setIsLoading(false);
      })
      .catch((er) => {
        setIsLoading(false);
        return getPayloadFromError(er, dispatch);
      });
  };

  return {
    isHas,
    isHasList,
    isLoading,
    handleToggle,
  };
};

export default useFetchToggle;
